import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceindaund() {



  const cardData =
  {
    keyword: 'Cab Service in Daund',
    heading: 'Sanavi Travels: Cab Service in Daund',
    headingDescription: 'Sanavi Travels offers reliable Cab Service in Daund, providing safe, comfortable, and hassle-free transportation for local travel, outstation journeys, railway station transfers, and pilgrimage trips. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cabs ensures clean interiors, air-conditioning, and ample luggage space for a smooth ride. With professional chauffeurs, flexible one-way and round-trip packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient doorstep pickup across Daund and nearby areas, covering popular destinations such as Shirdi, Shani Shingnapur, Pune, Baramati, Ahmednagar, and Ujjain. Choose Sanavi Travels for trusted cab services in Daund, delivering comfort, safety, and a seamless travel experience.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a paradise for bird lovers and nature enthusiasts. Often called the 'Bharatpur of Maharashtra,' it attracts migratory birds like flamingos, pelicans, and storks, especially during winter. Boat safaris and sunrise views make it a must-visit destination."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam near Daund offer a serene landscape of vast water spread and open skies. The area is ideal for peaceful outings, photography, and birdwatching, particularly during early mornings and evenings."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is an important local religious site in Daund, attracting devotees throughout the year. The temple is known for its calm spiritual atmosphere and traditional rituals performed during festivals."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is one of the major railway hubs in Maharashtra, connecting important routes toward Pune, Solapur, and southern India. The historic junction plays a vital role in trade, travel, and regional connectivity."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands around Bhigwan near Daund support rich biodiversity and seasonal migratory birds. Nature walks and boat rides allow visitors to experience untouched natural beauty and rural landscapes."
  },
  {
    "title": "Local Sugar Factories Area",
    "description": "Daund is surrounded by sugarcane fields and sugar factories that represent the agricultural backbone of the region. These areas highlight rural life and Maharashtra’s cooperative farming culture."
  },
  {
    "title": "Village Temples and Wadas",
    "description": "Traditional village temples and old wadas around Daund reflect the cultural and architectural heritage of rural Maharashtra. These sites offer insight into local traditions, festivals, and community life."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The countryside along Indapur Road near Daund offers scenic drives with open fields, canals, and sunset views. It is ideal for short nature breaks and relaxed travel experiences."
  },
  {
    "title": "Local Weekly Markets",
    "description": "Weekly markets in Daund are vibrant centers of local trade, selling fresh produce, grains, livestock, and daily essentials. They provide an authentic experience of rural Maharashtra’s lifestyle."
  },
  {
    "title": "Pilgrimage Routes Nearby",
    "description": "Daund lies on important travel routes connecting Pune, Solapur, Pandharpur, and Bhigwan. Many pilgrims use Daund as a transit point while visiting major religious destinations."
  }
]
,



"services": [
  {
    "name": "Cab Service in Daund",
    "description": "Cab Service in Daund offers reliable and comfortable transportation solutions for daily travel, railway transfers, and outstation journeys. Well-maintained, air-conditioned cabs with clean interiors and comfortable seating ensure a smooth travel experience. Experienced chauffeurs handle local routes, traffic conditions, and long-distance driving efficiently, ensuring timely pickups and safe drop-offs. Ideal for families, professionals, and regular travelers, this service supports flexible schedules and convenient point-to-point travel across Daund."
  },
  {
    "name": "Taxi Service Daund",
    "description": "Taxi Service Daund provides dependable taxi options for passengers traveling within Daund and nearby areas. Comfortable AC taxis with professional drivers ensure punctual service and safe driving. Suitable for local commutes, station transfers, and short trips, this service focuses on convenience, reliability, and customer satisfaction."
  },
  {
    "name": "AC Cab Daund",
    "description": "AC Cab Daund ensures a cool and comfortable ride for all types of journeys. Fully air-conditioned cabs with smooth suspension, clean interiors, and spacious seating reduce travel fatigue. Skilled chauffeurs ensure safe driving and efficient route planning, making this service ideal for families, senior citizens, and business travelers."
  },
  {
    "name": "Local Cab Daund",
    "description": "Local Cab Daund is ideal for short-distance travel within Daund, including homes, markets, offices, and nearby locations. Comfortable air-conditioned cabs with knowledgeable local drivers ensure quick and convenient transportation. This service is suitable for daily commuting, errands, and local travel needs."
  },
  {
    "name": "Outstation Cab Daund",
    "description": "Outstation Cab Daund provides reliable long-distance travel options from Daund to nearby cities and destinations. Well-maintained, air-conditioned vehicles with experienced chauffeurs ensure safe highway driving, comfortable seating, and timely arrivals. Ideal for family trips, pilgrimages, and business travel."
  },
  {
    "name": "Affordable Cab Daund",
    "description": "Affordable Cab Daund offers budget-friendly cab services without compromising on safety or comfort. Clean, air-conditioned cabs with trained drivers ensure smooth and economical travel. Ideal for students, families, and cost-conscious travelers seeking dependable transport in Daund."
  },
  {
    "name": "Chauffeur Driven Cab Daund",
    "description": "Chauffeur Driven Cab Daund provides a stress-free travel experience with professional drivers managing navigation, traffic, and schedules. Comfortable AC cabs allow passengers to relax during their journey. Especially suitable for elderly passengers, families, and business travelers, this service emphasizes safety and punctuality."
  },
  {
    "name": "Best Cab Service Daund",
    "description": "Best Cab Service Daund delivers high-quality transportation with well-maintained vehicles and trained chauffeurs. Fully air-conditioned cabs ensure comfort, while professional drivers ensure timely pickups and safe arrivals. Ideal for local travel, outstation trips, and railway transfers, this service focuses on reliability and customer satisfaction."
  },
  {
    "name": "Railway Station Taxi Daund",
    "description": "Railway Station Taxi Daund offers convenient taxi services for passengers arriving at or departing from Daund railway station. Drivers track train timings to ensure punctual pickups and smooth transfers. Comfortable AC taxis make this service ideal for families, senior citizens, and frequent travelers."
  },
  {
    "name": "Family Cab Daund",
    "description": "Family Cab Daund is designed to make family travel safe, comfortable, and convenient. Spacious air-conditioned cabs with ample luggage space accommodate all family members easily. Professional chauffeurs ensure smooth driving and flexible schedules, making it ideal for family outings and station transfers."
  },
  {
    "name": "Tourist Cab Daund",
    "description": "Tourist Cab Daund provides organized transportation for tourists visiting Daund and nearby attractions. Comfortable AC cabs with experienced drivers ensure a pleasant and informative travel experience. Perfect for families, couples, and groups planning sightseeing or leisure trips."
  },
  {
    "name": "Airport Transfer Cab Daund",
    "description": "Airport Transfer Cab Daund ensures punctual and hassle-free transfers between Daund and nearby airports. Professional drivers track flight schedules and provide timely pickups and drops in comfortable, air-conditioned vehicles. Ideal for business travelers, tourists, and families."
  },
  {
    "name": "Online Cab Booking Daund",
    "description": "Online Cab Booking Daund allows customers to easily reserve cabs for local, outstation, and airport travel. Users can select cab type, pickup location, and travel time with quick confirmation. This service ensures convenience, transparency, and smooth travel planning."
  },
  {
    "name": "Corporate Cab Daund",
    "description": "Corporate Cab Daund offers professional transportation solutions for business travelers and corporate employees. Comfortable AC cabs with trained chauffeurs ensure punctual travel for meetings, office commutes, and corporate events. This service focuses on reliability, professionalism, and comfort."
  },
  {
    "name": "Daund Travel Taxi",
    "description": "Daund Travel Taxi provides dedicated taxi solutions for travelers within and outside Daund. Comfortable air-conditioned cabs with professional chauffeurs ensure smooth travel for local trips, outstation journeys, and airport transfers. This service emphasizes comfort, safety, and dependable service."
  }
],
"tableData": [
  ["Cab Service in Daund", "Taxi Service Daund"],
  ["AC Cab Daund", "Local Cab Daund"],
  ["Outstation Cab Daund", "Affordable Cab Daund"],
  ["Chauffeur Driven Cab Daund", "Best Cab Service Daund"],
  ["Railway Station Taxi Daund", "Family Cab Daund"],
  ["Tourist Cab Daund", "Airport Transfer Cab Daund"],
  ["Online Cab Booking Daund", "Corporate Cab Daund"],
  ["Daund Travel Taxi", "—"]
]
,

"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Daund with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services in Daund, perfect for local travel, airport transfers, outstation trips, pilgrimages, and business journeys."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Cabs",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and regularly serviced cabs that ensure a smooth and relaxing ride throughout Daund and nearby destinations."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with Daund routes, ensuring safe and timely travel for all your cab needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for all cab services in Daund, including fuel, tolls, and driver allowances, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from immediate bookings, advance reservations, one-way, round-trip, or hourly cab services based on your requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every ride to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab services in Daund."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Daund?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable cab services throughout Daund.'
  },
  {
    question: 'How can I book a cab in Daund?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available in Daund?',
    answer: 'Sanavi Travels provides hatchbacks, sedans, SUVs, and premium cars to suit your travel preferences.'
  },
  {
    question: 'Are drivers experienced with local Daund routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with all routes in and around Daund.'
  },
  {
    question: 'Can I book a cab for airport transfers?',
    answer: 'Absolutely! We offer airport pickup and drop services to and from the nearest airports.'
  },
  {
    question: 'Is taxi/cab service available 24x7 in Daund?',
    answer: 'Yes, Sanavi Travels provides round-the-clock cab services in Daund.'
  },
  {
    question: 'Are the cabs sanitized before every ride?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before each trip.'
  },
  {
    question: 'What payment options are available for cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and cash payments.'
  },
  {
    question: 'Is customer support available during the ride?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab journey in Daund.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prakash Jadhav',
    feedback: 'Booked a cab service in Daund. Comfortable ride, professional driver, and very supportive customer service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aarti Kulkarni',
    feedback: 'Excellent cab service in Daund with punctual pickups and smooth travel experience. Highly recommended!',
    rating: 5
  }
];














































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Daund - Sanavi Travels",
  "description": "Sanavi Travels provides AC and chauffeur-driven cab services in Daund for local travel, outstation trips, railway station pickups, airport transfers, family trips, corporate travel, and tourist journeys. Affordable and reliable cab service in Daund.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Cab Service in Daund | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and chauffeur-driven cabs in Daund with Sanavi Travels. Ideal for local and outstation trips, railway station pickups, airport transfers, family, corporate, and tourist travel."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceindaund;